<template>
    <div class="group-auto-complete">
      <div v-if="editable">
        <a-auto-complete
          style="width: 100%"
          placeholder="输入群分类"
          optionLabelProp="value"
          ref="selector"
          :autoFocus="true"
          v-model="inputValue"
          @select="onSelect"
        >
          <template slot="dataSource">
            <a-select-option
              v-for="group in showGroupList"
              :key="group.group_name"
              :oriGroupData="group"
            >
              {{ group.group_name }}
            </a-select-option>
          </template>
          <a-input>
            <a-icon slot="suffix" type="down"/>
          </a-input>
        </a-auto-complete>
      </div>
      <div v-else>
        <span> {{ inputValue }} </span>
        <a-icon type="edit" @click="selectGroup"/>
      </div>
    </div>
</template>

<script>
import '../config/global'
const axios = require('axios')
export default {
  name: 'GroupAutoComplete',
  props: ['group', 'groups', 'chatroomname'],
  data () {
    return {
      addGroupUrlPostFix: 'add_group',
      editable: false,
      inputValue: this.group.group_name
    }
  },
  computed: {
    showGroupList: function () {
      let groupListTmp = this.groups
      if (this.inputValue) {
        let groupDup = this.groups.find(item => item.group_name === this.inputValue)
        console.log('groupDup', groupDup)
        groupListTmp = groupDup ? [groupDup] : [{group_name: this.inputValue, id: 0}]
        this.groups.forEach((group) => {
          if (group.group_name !== this.inputValue && group.group_name.startsWith(this.inputValue)) {
            groupListTmp.push(group)
          }
        })
      }
      return groupListTmp
    },
    addGroupUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.addGroupUrlPostFix
    }
  },
  watch: {
    group: function () {
      this.inputValue = this.group.group_name
    }
  },
  methods: {
    selectGroup () {
      this.editable = true
      this.$nextTick(function () {
        this.$refs.selector.focus()
      })
    },
    onSelect (selectValue, option) {
      console.log('onSelect')
      // let oriGroupData = option.data.attrs.oriGroupData
      // if (oriGroupData.id === 0) {
      //
      // }

      if (selectValue) {
        axios.post(this.addGroupUrl, {
          group_name: selectValue,
          chatroomname: this.chatroomname,
          token: sessionStorage.token
        }).then((data) => {
          console.log('data.err_code:', data.data.err_code)
          if (data.data.err_code === 0) {
            console.log('group:', data.data.content.group)
            let group = data.data.content.group
            // or can be computed?
            this.inputValue = group.group_name
            this.editable = false
            this.emitAddGroup(group)
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
      }
    },
    emitAddGroup (group) {
      this.$emit('add-group', group)
    }
  }
}
</script>

<style scoped>

</style>
